import { SET_FIREBASE, RESET_REALTIME_DB } from '../actions/types/index';

const INITIAL_STATE = {
  drivers: [],
  independentDrivers: [],
  externalDrivers: [],
  finance: {},
  financeGlobalData: {},
  generalConfig: {},
  shops: {},
  shop: {},
  menu: {},
  menuPOS: {},
  pushNotifications: {},
  hotlineAvailability: null
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_FIREBASE:
      return { ...state, [action.id]: action.payload };
    case RESET_REALTIME_DB:
      return INITIAL_STATE;
    default:
      return state;
  }
};
